import React, { ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';

interface DroppableProps {
  id: string;           // 确保 id 为字符串类型
  children: ReactNode;  // 明确 props 中 children 的类型
}

export function Droppable({ id, children }: DroppableProps) {
  const { isOver, setNodeRef } = useDroppable({
    id, // 使用 props.id
  });

  const style: React.CSSProperties = {
    opacity: isOver ? 0.8 : undefined,
  };

  return (
    <div className='track' ref={setNodeRef} style={style}>
      {children}
    </div>
  );
}
